<script lang="ts">
  import videoDirectory from 'shared/src/lessons/video-sources';
  import VideoJs from '$lib/components/video-js/VideoJs.svelte';
  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import type { ClientUserStore } from 'shared/src';
  import { autorun, observable, runInAction } from 'mobx';
  import { onDestroy } from 'svelte';
  import { createEventDispatcher } from 'svelte';

  export let lessonPage: UserLessonStore['pages'][number];
  export let clientUserStore: ClientUserStore;

  interface $$Events {
    video404: string;
    videoEnded: null;
  }

  const fallbackVideosBaseUrl = import.meta.env.VITE_CDN_VIDEO_URL + '/mp4';

  const dispatch = createEventDispatcher<{
    video404: string;
    videoEnded: null;
  }>();

  const props = observable({ lessonPage });
  $: {
    // updating lesson page
    runInAction(() => {
      props.lessonPage = lessonPage;
    });
  }

  let is404 = false;
  let videoInfo: {
    sources: string[];
    title: string;
  } | null = null;

  const destroyer = autorun(() => {
    const solfegeMethod = clientUserStore.preferences.solfegeMethod;
    const sameMinor = solfegeMethod.indexOf('solfege') !== -1 && props.lessonPage.video!.sameMinor;
    let solfegeMethodString = '';
    if (props.lessonPage.video!.solfegeMethod) {
      solfegeMethodString = sameMinor ? 'solfege' : solfegeMethod;
    }

    // Determine rhythmMethod to user for videos:
    let rhythmMethod = clientUserStore.preferences.rhythmMethod;
    rhythmMethod = 'american'; // KLUGE KLUGE KLUGE! GCR fix when british vids are made.
    const rhythmMethodString = props.lessonPage.video!.rhythm ? rhythmMethod : '';

    const videoName =
      props.lessonPage.video!.url.toLowerCase() + solfegeMethodString + rhythmMethodString;
    // console.log('videoName', videoName);
    const uTheorySource = `https://video.utheory.com/hls/${videoName}/index.m3u8`;
    const videoVimeoSources =
      videoDirectory.find((v) => v.name.toLowerCase() === videoName.toLowerCase())?.sources ?? [];

    const fallbackSource = `${fallbackVideosBaseUrl}/${videoName}Medium.mp4`;

    videoInfo = {
      sources: [uTheorySource, ...videoVimeoSources, fallbackSource],
      title: lessonPage.title,
    };
  });
  onDestroy(destroyer);
</script>

<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@vime/core@^5/themes/default.css" />
</svelte:head>

<div class="aspect-video m-auto">
  {#if videoInfo}
    <VideoJs
      videoSources={videoInfo.sources}
      autoplay
      on:video404={(detail) => {
        is404 = true;
        dispatch('video404', detail);
      }}
      on:videoEnded={() => {
        dispatch('videoEnded');
      }}
    />
  {:else if is404}
    <div class="p-8">Sorry, that video was not found.</div>
  {/if}
</div>
